import React from 'react';
import { Box, Typography, Paper, alpha, Stack, Grid2 as Grid } from '@mui/material';
import { TuneOutlined } from '@mui/icons-material';
import ModifyPreferences from './ModifyPreference';
import '../style.css';

const PreferencesConfig = () => {
  return (
    <Box sx={{ p: { xs: 1, md: 2 }, bgcolor: '#F4F6F8', minHeight: '100vh' }}>
      {/* SECTION HEADER CARD */}
      <Paper
        elevation={0}
        sx={{
          p: 3,
          mb: 2,
          borderRadius: '16px',
          border: '1px solid',
          borderColor: 'divider',
          background: '#fff',
        }}
      >
        <Stack direction="row" spacing={2} alignItems="center">
          <Box
            sx={{
              p: 1.5,
              borderRadius: '12px',
              bgcolor: alpha('#1976d2', 0.1),
              color: 'primary.main',
              display: 'flex',
            }}
          >
            <TuneOutlined fontSize="medium" />
          </Box>
          <Box>
            <Typography variant="h5" fontWeight={700} color="text.primary">
              Personal Preferences
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
              Manage your custom alert settings to receive real-time updates on system activities.
            </Typography>
          </Box>
        </Stack>
      </Paper>

      {/* CONTENT AREA */}
      <Paper
        elevation={0}
        sx={{
          p: 3,
          mb: 4,
          borderRadius: '16px',
          border: '1px solid',
          borderColor: 'divider',
          background: '#fff',
        }}
      >
        <ModifyPreferences />
      </Paper>
    </Box>
  );
};

export default PreferencesConfig;
